import Request from './Request'
import constants from '../constants/constant'

const DataFileService = {
	async uploadDataFile(client_id, file, data={}) {
		let formData = new FormData()
		formData.append("data", file)
		for(let i in data) {
			formData.append(i, data[i])
		}
		return await Request.formPost(`/api/clients/${client_id}/data-files/upload`, formData)
	},
	async getClientDataFiles(client_id, params={}) {
		return await Request.get(`/api/clients/${client_id}/data-files`, params)
	},
	async downloadDataFileOriginFile(client_id, id) {
		return await Request.get(`/api/clients/${client_id}/data-files/${id}/download`)
	},
	async getClientDataFileById(client_id, id, params={}) {
		return await Request.get(`/api/clients/${client_id}/data-files/${id}`, params)
	},
	async finalizeDataFile(client_id, id) {
		return await Request.post(`/api/clients/${client_id}/data-files/${id}/finalize`)
	},
	async unfinalizeDataFile(client_id, id) {
		return await Request.post(`/api/clients/${client_id}/data-files/${id}/unfinalize`)
	},
	async deleteDataFile(client_id, id) {
		return await Request._delete(`/api/clients/${client_id}/data-files/${id}`)
	},
	async processDataFile(client_id, id) {
		return await Request.post(`/api/clients/${client_id}/data-files/${id}/process`)
	},
	async updateDataFile(client_id, id, data) {
		return await Request.post(`/api/clients/${client_id}/data-files/${id}`, data)
	},
	async getStatisticsByType(client_id, id, type) {
		return await Request.get(`/api/clients/${client_id}/data-files/${id}/statistics/${type}`)
	},
	async downloadDataFileOriginData(client_id, id) {
		window.open(`${constants.BACKEND_DOMAIN}/clients/${client_id}/data-files/${id}/download?_access_token=${localStorage.getItem('access_token')}`, '_blank')
	},
	async clientDataFileBackup(client_id) {
		window.open(`${constants.BACKEND_DOMAIN}/clients/${client_id}/data-files/backup?_access_token=${localStorage.getItem('access_token')}`, '_blank')
	},
	async backdate(client_id, periodStart, months) {
		return await Request.post(`/api/clients/${client_id}/data-file/backdate`, {periodStart, months})
	},
	async perpetuate(client_id, periodStart, months) {
		return await Request.post(`/api/clients/${client_id}/data-file/perpetuate`, {periodStart, months})
	},
	async batchUnfinalize(client_id, periodStart, periodEnd) {
		return await Request.post(`/api/clients/${client_id}/data-file/unfinalize/batch`, {periodStart, periodEnd})
	},
	async syncCloudData(client_id) {
		return await Request.post(`/api/clients/${client_id}/sync-flight-data`)
	},
}

export default DataFileService